import { useEffect, useState } from "react";
import axios from "axios";
import { formatAcademyDisplayName } from "../utils/playerHelpers";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const labels = { total: "Σύνολο", friendly: "Φιλικοί", competitive: "Επίσημοι", other: "Λοιποί" };
const outcomes = { W: ["Ν", "Νίκη", "bg-emerald-500/20 text-emerald-300"], D: ["Ι", "Ισοπαλία", "bg-zinc-700 text-zinc-200"], L: ["Η", "Ήττα", "bg-red-500/20 text-red-300"] };

export const AcademyStats = ({ groupId, onSelect }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [scope, setScope] = useState("total");
  useEffect(() => {
    let active = true;
    setData(null); setError(false); setScope("total");
    axios.get(`${API}/academy-groups/${groupId}/stats`).then(r => { if (active) setData(r.data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [groupId]);
  const prefix = `academy-stats-${groupId}`;
  if (error) return <p role="alert" className="text-sm text-red-400" data-testid={`${prefix}-error`}>Τα στατιστικά δεν είναι διαθέσιμα προσωρινά.</p>;
  if (!data) return <p role="status" className="text-sm text-zinc-400" data-testid={`${prefix}-loading`}>Φόρτωση στατιστικών…</p>;
  const record = data[scope];
  return <section className="py-5 space-y-5" data-testid={prefix}>
    <h2 className="text-lg font-semibold text-white" data-testid={`${prefix}-season`}>Στατιστικά {data.season || ""}</h2>
    <div className="flex flex-wrap gap-2" role="group" aria-label="Τύπος αγώνων">
      {Object.entries(labels).filter(([key]) => key !== "other" || data.other.played > 0).map(([key, label]) =>
        <button key={key} type="button" aria-pressed={scope === key} onClick={() => setScope(key)} data-testid={`${prefix}-filter-${key}`}
          className={`px-3 py-2 rounded-lg text-sm transition-colors ${scope === key ? "bg-[#F5A623] text-black" : "bg-zinc-900 text-zinc-300 hover:bg-zinc-800"}`}>{label}</button>)}
    </div>
    <dl className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      {[["played", "Αγώνες"], ["wins", "Νίκες"], ["draws", "Ισοπαλίες"], ["losses", "Ήττες"], ["goals_for", "Τέρματα υπέρ"], ["goals_against", "Τέρματα κατά"]].map(([key, label]) =>
        <div key={key} className="border border-zinc-800 rounded-lg px-3 py-4 min-w-0" data-testid={`${prefix}-${key.replaceAll("_", "-")}`}>
          <dt className="text-xs text-zinc-400 break-words">{label}</dt><dd className="text-3xl font-['Bebas_Neue'] text-[#F5A623] mt-1">{record[key]}</dd>
        </div>)}
    </dl>
    {record.unrecorded_results > 0 && <p className="text-xs text-zinc-400" data-testid={`${prefix}-incomplete`}>Αγώνες χωρίς πλήρες καταγεγραμμένο αποτέλεσμα: {record.unrecorded_results}</p>}
    {record.played === 0 && <p className="text-sm text-zinc-500" data-testid={`${prefix}-empty`}>Δεν υπάρχουν ολοκληρωμένοι αγώνες.</p>}
    {record.recent_form.length > 0 && <div data-testid={`${prefix}-form`}>
      <h3 className="text-sm text-zinc-400 mb-2">Πρόσφατη φόρμα · Νεότερος πρώτα</h3>
      <div className="flex flex-wrap gap-2">{record.recent_form.map(f => {
        const [letter, label, color] = outcomes[f.result];
        return <button key={f.fixture_id} type="button" onClick={() => onSelect?.(f.fixture_id)} disabled={!onSelect}
          aria-label={`${label} · ${new Date(f.match_date).toLocaleDateString("el-GR")}`} title={`${label} · ${new Date(f.match_date).toLocaleDateString("el-GR")}`}
          className={`w-10 h-10 rounded-lg font-bold transition-opacity hover:opacity-80 ${color}`} data-testid={`${prefix}-form-${f.fixture_id}`}>{letter}</button>;
      })}</div>
    </div>}
    {scope === "total" && data.players.length > 0 && <div className="grid sm:grid-cols-3 gap-6 border-t border-zinc-800 pt-5">
      {[["goals", "Σκόρερ"], ["assists", "Ασίστ"], ["appearances", "Συμμετοχές"]].map(([key, label]) => {
        const rows = [...data.players].filter(p => p.statistics[key] > 0).sort((a, b) => b.statistics[key] - a.statistics[key]).slice(0, 10);
        return rows.length > 0 && <section key={key} data-testid={`${prefix}-leaders-${key}`}><h3 className="text-sm text-[#F5A623] mb-3">{label}</h3>
          {rows.map(p => <div key={p.id} className="flex justify-between gap-3 text-sm py-2 border-b border-zinc-900" data-testid={`${prefix}-${key}-${p.id}`}><span className="text-zinc-300 break-words min-w-0">{formatAcademyDisplayName(p.name)}</span><strong className="text-white">{p.statistics[key]}</strong></div>)}
        </section>;
      })}
    </div>}
  </section>;
};